<template>
  <div id="reportPage">
    
    <article class="report-card">
    <div class="title-wrapper mb-4">
        <header class="login-title">
          <a href="#" class="brand" @click.prevent="goToHome">
            USERS
          </a>
        </header>
      <UserMenu :roles="roles" :user-name="userName" />
    </div>
    
      <div class="table-section">
      <div class="table-header">
        <div class="subtitle-row">

          <button
            class="btn btn-secondary add-user-btn"
            @click="openCreateModal"
          >
            + Add user
          </button>
        </div>
      </div>
        <div class="table-scroll">
          <table class="table">
            <thead>
              <tr>
                <th class="campaign-header-cell">
                  <div class="campaign-header-cell-inner">
                    <span>USER #</span>
                    <button
                      type="button"
                      ref="userFilterBtn"
                      class="filter-icon-btn"
                      :class="{ active: userFilterActive }"
                      @click.stop="toggleUserFilterPopover"
                      title="Filter by user"
                    >
                      <font-awesome-icon icon="filter" />
                      <span v-if="userFilterActive" class="filter-badge">1</span>
                    </button>
                  </div>
                </th>
                <th class="campaign-header-cell">
                  <div class="campaign-header-cell-inner">
                    <span>ROLE</span>
                    <button
                      type="button"
                      ref="roleFilterBtn"
                      class="filter-icon-btn"
                      :class="{ active: roleFilterSelectedCount > 0 }"
                      @click.stop="toggleRoleFilterPopover"
                      title="Filter by role"
                    >
                      <font-awesome-icon icon="filter" />
                      <span v-if="roleFilterSelectedCount > 0" class="filter-badge">{{ roleFilterSelectedCount }}</span>
                    </button>
                  </div>
                </th>
                <th>CREATED AT</th>
                <th class="col-active">POINT</th>
                <th class="campaign-header-cell col-active">
                  <div class="campaign-header-cell-inner">
                    <span>ACTIVE</span>
                    <button
                      type="button"
                      ref="activeFilterBtn"
                      class="filter-icon-btn"
                      :class="{ active: activeFilterIsActive }"
                      @click.stop="toggleActiveFilterPopover"
                      title="Filter by status"
                    >
                      <font-awesome-icon icon="filter" />
                      <span v-if="activeFilterIsActive" class="filter-badge">1</span>
                    </button>
                  </div>
                </th>
                <th>ACTIONS</th>
              </tr>
            </thead>
              <tbody>
                <tr v-for="client in filteredRows" :key="client.id">
                  <td
                  v-for="col in columns"
                  :key="col.key"
                  class="td-left"
                >
                  <template v-if="col.key === 'roles'">
                    {{ client.roles.join(', ') }}
                  </template>

                  <template v-else>
                    {{ client[col.key] }}
                  </template>
                </td>
                  <td class="td-left col-active">
                    <span
                      class="status-badge"
                      :class="client.active ? 'active' : 'inactive'"
                    >
                      <span class="dot"></span>
                      {{ client.active ? 'Active' : 'Inactive' }}
                    </span>
                  </td>

                  <td class="td-center col-actions">
                    <div class="actions-wrapper">
                      <button
                        class="dots-btn"
                        @click.stop="toggleActions(client.id)"
                        aria-label="Actions"
                      >
                        ⋮
                      </button>

                      <div
                        v-if="openActionsId === client.id"
                        class="actions-popover"
                      >
                        <button
                          class="popover-btn"
                          @click="openEditFromMenu(client)"
                        >
                          ✏ Edit user
                        </button>

                        <button
                          class="popover-btn secondary"
                          @click="toggleActive(client)"
                        >
                          {{ client.active ? 'Deactivate' : 'Activate' }}
                        </button>
                      </div>
                    </div>
                </td>
                </tr>
              </tbody>
          </table>
        </div>
        <div class="footer-actions">
        <button class="btn btn-secondary" @click="openCreateModal">
          + Add user
        </button>
      </div>

      </div>

      
    </article>

    <!-- User filter popover -->
    <Teleport to="body">
      <div
        v-if="showUserFilterModal"
        ref="userFilterPopover"
        class="filter-popover caller-filter-popover"
        :style="userFilterPopoverStyle"
      >
        <div class="filter-popover-header">
          <span class="filter-popover-title">Filter by User</span>
          <button type="button" class="filter-popover-close" @click="closeUserFilterModal" aria-label="Close">×</button>
        </div>
        <div class="filter-popover-body">
          <input
            v-model="userFilterTemp"
            type="text"
            class="filter-popover-search"
            placeholder="User (contains)..."
          />
        </div>
        <div class="filter-popover-footer">
          <button type="button" class="btn btn-sm btn-outline-secondary" @click="clearUserFilter">Clear</button>
          <button type="button" class="btn btn-sm btn-primary" @click="applyUserFilter">Apply</button>
        </div>
      </div>
      <!-- Role filter popover (distinct list + search) -->
      <div
        v-if="showRoleFilterModal"
        ref="roleFilterPopover"
        class="filter-popover filter-popover-role"
        :style="roleFilterPopoverStyle"
      >
        <div class="filter-popover-header">
          <span class="filter-popover-title">Filter by Role</span>
          <button type="button" class="filter-popover-close" @click="closeRoleFilterModal" aria-label="Close">×</button>
        </div>
        <div class="filter-popover-body">
          <input
            v-model="roleFilterSearch"
            type="text"
            class="filter-popover-search"
            placeholder="Search (contains)..."
          />
          <div class="filter-popover-list">
            <label
              v-for="opt in filteredRoleOptions"
              :key="opt"
              class="filter-popover-item"
            >
              <input
                type="checkbox"
                :value="opt"
                v-model="roleFilterSelected"
              />
              <span>{{ opt }}</span>
            </label>
            <div v-if="filteredRoleOptions.length === 0" class="filter-popover-empty">
              No options match
            </div>
          </div>
        </div>
        <div class="filter-popover-footer">
          <button type="button" class="btn btn-sm btn-outline-secondary" @click="selectAllRoles">All</button>
          <button type="button" class="btn btn-sm btn-outline-secondary" @click="deselectAllRoles">None</button>
          <button type="button" class="btn btn-sm btn-primary" @click="applyRoleFilter">Apply</button>
        </div>
      </div>
      <!-- Active filter popover -->
      <div
        v-if="showActiveFilterModal"
        ref="activeFilterPopover"
        class="filter-popover filter-popover-active"
        :style="activeFilterPopoverStyle"
      >
        <div class="filter-popover-header">
          <span class="filter-popover-title">Filter by Status</span>
          <button type="button" class="filter-popover-close" @click="closeActiveFilterModal" aria-label="Close">×</button>
        </div>
        <div class="filter-popover-body">
          <div class="filter-popover-list">
            <label
              v-for="opt in [{value:'all',label:'All'},{value:'active',label:'Active'},{value:'inactive',label:'Inactive'}]"
              :key="opt.value"
              class="filter-popover-item"
            >
              <input type="radio" :value="opt.value" v-model="activeFilterTemp" />
              <span>{{ opt.label }}</span>
            </label>
          </div>
        </div>
        <div class="filter-popover-footer">
          <button type="button" class="btn btn-sm btn-outline-secondary" @click="clearActiveFilter">Clear</button>
          <button type="button" class="btn btn-sm btn-primary" @click="applyActiveFilter">Apply</button>
        </div>
      </div>
    </Teleport>

    <!-- CREATE MODAL -->
      <transition name="fade">
        <div v-if="showCreateModal" class="modal-overlay">
          <div class="modal-content">
            <h2 class="modal-title">Create User</h2>
            <form @submit.prevent="createClient" class="modal-form">
              
              <!-- Section: Account Info -->
              <section class="modal-section">
                <div class="form-grid">
                  <div class="form-field">
                    <label for="new_user">Username</label>
                    <input id="new_user" v-model="newClient.user" placeholder="Username" required />
                  </div>
                  <div class="form-field">
                    <label for="new_password">Password</label>
                    <input id="new_password" v-model="newClient.password" type="password" placeholder="Password" required />
                  </div>
                  <div class="form-field">
                    <label for="new_email">Email</label>
                    <input id="new_email" v-model="newClient.email" type="email" placeholder="client@example.com" />
                  </div>
                  <div class="form-field">
                    <label for="new_role">Role</label>
                    <Multiselect
                      id="new_role"
                      v-model="newClient.roles"
                      :options="roleOptions"
                      placeholder="Select role"
                      mode="tags"
                      :allow-empty="false"
                    />
                  </div>
                </div>
              </section>

              <!-- Section: Company Info -->
              <section class="modal-section">
                <div class="form-grid">
                  <div class="form-field company-alone">
                    <label for="new_company_name">Company Name</label>
                    <input id="new_company_name" v-model="newClient.company_name" placeholder="Company name" />
                  </div>
                  <div class="form-field e">
                    <label for="new_owner_name">Owner Name</label>
                    <input id="new_owner_name" v-model="newClient.owner_name" placeholder="Owner name" />
                  </div>
                  <div class="form-field">
                    <label for="new_owner_phone">Owner Phone</label>
                    <input id="new_owner_phone" v-model="newClient.owner_phone" placeholder="+1 555 555 5555" />
                  </div>
                  <div class="form-field">
                    <label for="new_contact_name">Contact Name</label>
                    <input id="new_contact_name" v-model="newClient.contact_name" placeholder="Contact name" />
                  </div>
                  <div class="form-field">
                    <label for="new_contact_phone">Contact Phone</label>
                    <input id="new_contact_phone" v-model="newClient.contact_phone" placeholder="+1 555 555 5555" />
                  </div>
                  <div class="form-field">
                    <label for="new_price_per_transfer">Price per Transfer</label>
                    <input
                      id="new_price_per_transfer"
                      v-model="newClient.price_per_transfer"
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="e.g. 25.00"
                    />
                  </div>
                  <div class="form-field">
                    <label>Transfer Numbers</label>
                    <div class="transfer-numbers-wrapper">
                      <!-- Список добавленных номеров -->
                      <div v-for="(num, index) in newClient.transfer_numbers" :key="index" class="transfer-number-row">
                        {{ num }}
                        <button
                          type="button"
                          class="remove-number-btn"
                          @click="removeTransferNumber(index)"
                          aria-label="Remove number"
                        >
                          ×
                        </button>
                      </div>

                      <!-- Поле ввода нового номера, появляется по клику на плюс -->
                      <div v-if="addingNumber" class="transfer-number-row">
                        <input v-model="newNumber" placeholder="+1 555 555 5555" />
                        <button
                          type="button"
                          class="confirm-number-btn"
                          @click="confirmAddNumber"
                          aria-label="Confirm number"
                        >
                          ✓
                        </button>

                        <button
                          type="button"
                          class="remove-number-btn"
                          @click="cancelAddNumber"
                          aria-label="Remove number"
                        >
                          ×
                        </button>
                      </div>
                    </div>

                    <!-- Маленький плюсик для добавления -->
                    <button type="button" class="btn btn-secondary add-number-btn" @click="showAddNumberInput" v-if="!addingNumber">
                      ➕
                    </button>
                  </div>
                </div>
              </section>

              <!-- Section: Contact Info -->
              <section class="modal-section">
                <div class="form-grid">
                  
                  <div class="form-field" style="display: flex; align-items: flex-start; gap: 12px;">
                    <label for="new_sms_enabled">SMS Enabled</label>
                    <div class="toggle-switch">
                      <input type="checkbox" id="new_sms_enabled" v-model="newClient.sms_enabled" />
                      <span class="slider"></span>
                    </div>
                  </div>
                </div>
              </section>

              <!-- Error message -->
              <div v-if="createError" class="create-error">
                {{ createError }}
              </div>

              <!-- Modal Actions -->
              <div class="modal-actions">
                <button type="submit" class="btn btn-primary">Create</button>
                <button type="button" class="btn btn-secondary" @click="closeCreateModal">Cancel</button>
              </div>

            </form>
          </div>
        </div>
      </transition>

    <transition name="fade">
      <div v-if="showEditModal" class="modal-overlay">
        <div class="modal-content">
          <h2 class="modal-title">Edit User</h2>

          <form @submit.prevent="updateClient(editingClient)" class="modal-form">

            <!-- Section: Account Info -->
            <section class="modal-section">
              <div class="form-grid">
                <div class="form-field">
                  <label for="username">Username</label>
                  <input id="username" v-model="editingClient.user" disabled placeholder="Username" />
                </div>
                <div class="form-field">
                  <label for="email">Email</label>
                  <input id="email" v-model="editingClient.email" type="email" placeholder="client@example.com" />
                </div>
                <div class="form-field">
                  <label for="role">Role</label>
                  <Multiselect
                    id="role"
                    mode="tags"
                    v-model="editingClient.roles"
                    :options="roleOptions"
                    :allow-empty="false"
                    placeholder="Select role"
                  />
                </div>
                <div class="form-field">
                  <label for="edit_password">New password</label>
                  <input
                    id="edit_password"
                    v-model="editingClient.password"
                    type="password"
                    placeholder="Leave blank to keep current"
                    autocomplete="new-password"
                  />
                </div>
              </div>
            </section>

            <!-- Section: Company Info -->
            <section class="modal-section">
              <div class="form-grid">
                <div class="form-field company-alone">
                  <label for="company_name">Company Name</label>
                  <input id="company_name" v-model="editingClient.company_name" placeholder="Company name" />
                </div>
                <div class="form-field">
                  <label for="owner_name">Owner Name</label>
                  <input id="owner_name" v-model="editingClient.owner_name" placeholder="Owner name" />
                </div>
                <div class="form-field">
                  <label for="owner_phone">Owner Phone</label>
                  <input id="owner_phone" v-model="editingClient.owner_phone" placeholder="+1 555 555 5555" />
                </div>
                <div class="form-field">
                  <label for="contact_name">Contact Name</label>
                  <input id="contact_name" v-model="editingClient.contact_name" placeholder="Contact name" />
                </div>
                <div class="form-field">
                  <label for="contact_phone">Contact Phone</label>
                  <input id="contact_phone" v-model="editingClient.contact_phone" placeholder="+1 555 555 5555" />
                </div>
                <div class="form-field">
                  <label for="price_per_transfer">Price per Transfer</label>
                  <input
                    id="price_per_transfer"
                    v-model="editingClient.price_per_transfer"
                    type="number"
                    min="0"
                    step="0.01"
                    placeholder="e.g. 25.00"
                  />
                </div>
              </div>
            </section>
            <section class="modal-section">
              <div class="form-grid">
                <div class="form-field">
                  <label>Transfer Numbers</label>

                  <div class="transfer-numbers-wrapper">
                    <!-- существующие номера -->
                    <div
                      v-for="(num, index) in editingClient.transfer_numbers"
                      :key="index"
                      class="transfer-number-row"
                    >
                      {{ num }}
                      <button
                        type="button"
                        class="remove-number-btn"
                        @click="removeEditTransferNumber(index)"
                        aria-label="Remove number"
                      >
                        ×
                      </button>
                    </div>

                    <!-- input для добавления -->
                    <div v-if="editingAddingNumber" class="transfer-number-row">
                      <input
                        v-model="editingNewNumber"
                        placeholder="+1 555 555 5555"
                      />
                      <button type="button" class="confirm-number-btn" @click="confirmEditAddNumber">✓</button>
                      <button type="button" class="remove-number-btn" @click="cancelEditAddNumber">×</button>
                    </div>
                  </div>

                  <!-- плюсик -->
                  <button
                    type="button"
                    class="btn btn-secondary add-number-btn"
                    v-if="!editingAddingNumber"
                    @click="showEditAddNumberInput"
                  >
                    ➕
                  </button>
                </div>
              </div>
            </section>

            <!-- Section: Contact Info -->
            <section class="modal-section">
              <div class="form-grid">
                
                  <div class="form-field" style="display: flex; align-items: flex-start; gap: 12px;">
                  <label for="sms_enabled">SMS Enabled</label>
                  <div class="toggle-switch">
                    <input type="checkbox" id="sms_enabled" v-model="editingClient.sms_enabled" />
                    <span class="slider"></span>
                  </div>
                </div>
              </div>
            </section>

            <!-- Modal Actions -->
            <div class="modal-actions-between">
                <div class="right-actions">
                  <button type="submit" class="btn btn-primary">Save</button>
                  <button type="button" class="btn btn-secondary" @click="closeEditModal">
                    Cancel
                  </button>
                </div>
            </div>

          </form>
        </div>
      </div>
    </transition>


  </div>
</template>

<script>
import UserMenu from '@/components/UserMenu.vue'
export default {
  components: { UserMenu },
  data() {
    
    return {
        columns: [
          { key: "user", label: "USER #" },
          { key: "roles", label: "ROLE"},
          { key: "created_at", label: "CREATED AT" },
          { key: "point", label: "POINT" },
        ],
        username: "",
        roleOptions: [],
        activeFilter: "active",
        activeFilterTemp: "active",
        showActiveFilterModal: false,
        activeFilterPopoverStyle: {},
        activeFilterClickOutside: null,
        rows: [],
        showCreateModal: false,
        createError: "",
        editingCell: null,
        showEditModal: false,
        editingClient: null,
        editedRows: new Set(),
        openActionsId: null,
        userFilter: "",
        showUserFilterModal: false,
        userFilterTemp: "",
        userFilterPopoverStyle: {},
        userFilterClickOutside: null,
        roleFilter: [],
        showRoleFilterModal: false,
        roleFilterSearch: "",
        roleFilterSelected: [],
        roleFilterPopoverStyle: {},
        roleFilterClickOutside: null,
        editingNewNumber: "",
        editingAddingNumber: false,
        roles: [],
        newNumber: "",
        addingNumber: false,
        newClient: {
          user: "",
          password: "",
          roles: [],
          transfer_numbers: [],
          company_name: "",
          owner_name: "",
          owner_phone: "",
          contact_name: "",
          contact_phone: "",
          email: "",
          sms_enabled: false,
          price_per_transfer: "",
        },

    };
  },
  computed: {
    filteredRows() {
      const q = (this.userFilter || "").trim().toLowerCase();
      const roleArr = Array.isArray(this.roleFilter) ? this.roleFilter : [];
      const matchUser = (client) =>
        !q || String(client.user ?? "").toLowerCase().includes(q);
      const matchRole = (client) => {
        if (roleArr.length === 0) return true;
        const roles = client.roles || [];
        return roles.some((r) => roleArr.includes(String(r ?? "").trim()));
      };
      const matchActive = (client) => {
        if (this.activeFilter === "all") return true;
        if (this.activeFilter === "active") return client.active === true;
        if (this.activeFilter === "inactive") return client.active === false;
      };
      return (this.rows || []).filter(
        (client) => matchUser(client) && matchRole(client) && matchActive(client)
      );
    },
    userFilterActive() {
      return (this.userFilter || "").toString().trim() !== "";
    },
    roleOptions() {
      const seen = new Set();
      for (const client of this.rows || []) {
        const arr = client.roles || [];
        for (const r of arr) {
          const s = String(r ?? "").trim();
          if (s !== "") seen.add(s);
        }
      }
      return [...seen].sort((a, b) => a.localeCompare(b));
    },
    filteredRoleOptions() {
      const q = (this.roleFilterSearch || "").trim().toLowerCase();
      if (!q) return this.roleOptions || [];
      return (this.roleOptions || []).filter((opt) =>
        String(opt || "").toLowerCase().includes(q)
      );
    },
    roleFilterSelectedCount() {
      return Array.isArray(this.roleFilter) ? this.roleFilter.length : 0;
    },
    activeFilterIsActive() {
      return this.activeFilter !== "all";
    },
  },
  mounted() {
    const username = localStorage.getItem('username');
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.href = '/login';
      return;
    }
    this.username = username;
    this.fetchClients();
    this.fetchRoles();
    this.check_role();
    document.title = "Customers";
  },
  beforeUnmount() {
    this.removeUserFilterClickOutside();
    this.removeRoleFilterClickOutside();
    this.removeActiveFilterClickOutside();
  },
  methods: {
    isPasswordStrong(password) {
      const regex = /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;
      return regex.test(password);
    },
    showEditAddNumberInput() {
      this.editingAddingNumber = true
      this.editingNewNumber = ""
    },

    // подтвердить добавление
    confirmEditAddNumber() {
    const normalized = this.editingNewNumber

    if (!this.isValidUSPhone(normalized)) {
      alert("Phone must be US number: 11 digits starting with +1")
      return
    }

    if (!this.editingClient.transfer_numbers) {
      this.editingClient.transfer_numbers = []
    }

    this.editingClient.transfer_numbers.push(normalized)
    this.editingNewNumber = ""
    this.editingAddingNumber = false
  },

    cancelEditAddNumber() {
      this.editingNewNumber = ""
      this.editingAddingNumber = false
    },

    toggleUserFilterPopover() {
      if (this.showUserFilterModal) {
        this.closeUserFilterModal();
      } else {
        this.openUserFilterModal();
      }
    },
    openUserFilterModal() {
      this.closeRoleFilterModal();
      this.userFilterTemp = this.userFilter || "";
      this.showUserFilterModal = true;
      this.$nextTick(() => this.positionUserFilterPopover());
      this.addUserFilterClickOutside();
    },
    closeUserFilterModal() {
      this.showUserFilterModal = false;
      this.removeUserFilterClickOutside();
    },
    positionUserFilterPopover() {
      const btn = this.$refs.userFilterBtn;
      if (!btn) return;
      const rect = btn.getBoundingClientRect();
      const gap = 4;
      const popoverWidth = 280;
      let left = rect.left;
      if (left + popoverWidth > window.innerWidth) {
        left = Math.max(8, window.innerWidth - popoverWidth - 8);
      }
      this.userFilterPopoverStyle = {
        position: 'fixed',
        top: `${rect.bottom + gap}px`,
        left: `${left}px`,
        zIndex: '9999'
      };
    },
    applyUserFilter() {
      this.userFilter = (this.userFilterTemp || "").trim();
      this.closeUserFilterModal();
    },
    toggleActiveFilterPopover() {
      if (this.showActiveFilterModal) {
        this.closeActiveFilterModal();
      } else {
        this.openActiveFilterModal();
      }
    },
    openActiveFilterModal() {
      this.closeUserFilterModal();
      this.closeRoleFilterModal();
      this.activeFilterTemp = this.activeFilter;
      this.showActiveFilterModal = true;
      this.$nextTick(() => this.positionActiveFilterPopover());
      this.addActiveFilterClickOutside();
    },
    closeActiveFilterModal() {
      this.showActiveFilterModal = false;
      this.removeActiveFilterClickOutside();
    },
    positionActiveFilterPopover() {
      const btn = this.$refs.activeFilterBtn;
      if (!btn) return;
      const rect = btn.getBoundingClientRect();
      const gap = 4;
      const popoverWidth = 200;
      let left = rect.left;
      if (left + popoverWidth > window.innerWidth) {
        left = Math.max(8, window.innerWidth - popoverWidth - 8);
      }
      this.activeFilterPopoverStyle = {
        position: 'fixed',
        top: `${rect.bottom + gap}px`,
        left: `${left}px`,
        zIndex: '9999'
      };
    },
    applyActiveFilter() {
      this.activeFilter = this.activeFilterTemp;
      this.closeActiveFilterModal();
    },
    clearActiveFilter() {
      this.activeFilterTemp = "all";
      this.activeFilter = "all";
      this.closeActiveFilterModal();
    },
    addActiveFilterClickOutside() {
      this.removeActiveFilterClickOutside();
      setTimeout(() => {
        this.activeFilterClickOutside = (e) => {
          const popover = this.$refs.activeFilterPopover;
          const btn = this.$refs.activeFilterBtn;
          if (popover && popover.contains(e.target)) return;
          if (btn && btn.contains(e.target)) return;
          this.closeActiveFilterModal();
        };
        document.addEventListener("click", this.activeFilterClickOutside);
      }, 0);
    },
    removeActiveFilterClickOutside() {
      if (this.activeFilterClickOutside) {
        document.removeEventListener("click", this.activeFilterClickOutside);
        this.activeFilterClickOutside = null;
      }
    },
    clearUserFilter() {
      this.userFilterTemp = "";
      this.userFilter = "";
      this.closeUserFilterModal();
    },
    addUserFilterClickOutside() {
      this.removeUserFilterClickOutside();
      setTimeout(() => {
        this.userFilterClickOutside = (e) => {
          const popover = this.$refs.userFilterPopover;
          const btn = this.$refs.userFilterBtn;
          if (popover && popover.contains(e.target)) return;
          if (btn && btn.contains(e.target)) return;
          this.closeUserFilterModal();
        };
        document.addEventListener("click", this.userFilterClickOutside);
      }, 0);
    },
    removeUserFilterClickOutside() {
      if (this.userFilterClickOutside) {
        document.removeEventListener("click", this.userFilterClickOutside);
        this.userFilterClickOutside = null;
      }
    },

    toggleRoleFilterPopover() {
      if (this.showRoleFilterModal) {
        this.closeRoleFilterModal();
      } else {
        this.openRoleFilterModal();
      }
    },
    openRoleFilterModal() {
      this.closeUserFilterModal();
      this.roleFilterSelected = Array.isArray(this.roleFilter)
        ? [...this.roleFilter]
        : this.roleFilter ? [this.roleFilter] : [];
      this.roleFilterSearch = "";
      this.showRoleFilterModal = true;
      this.$nextTick(() => this.positionRoleFilterPopover());
      this.addRoleFilterClickOutside();
    },
    closeRoleFilterModal() {
      this.showRoleFilterModal = false;
      this.removeRoleFilterClickOutside();
    },
    positionRoleFilterPopover() {
      const btn = this.$refs.roleFilterBtn;
      if (!btn) return;
      const rect = btn.getBoundingClientRect();
      const gap = 4;
      const popoverWidth = 320;
      let left = rect.left;
      if (left + popoverWidth > window.innerWidth) {
        left = Math.max(8, window.innerWidth - popoverWidth - 8);
      }
      this.roleFilterPopoverStyle = {
        position: 'fixed',
        top: `${rect.bottom + gap}px`,
        left: `${left}px`,
        zIndex: '9999'
      };
    },
    applyRoleFilter() {
      this.roleFilter = [...this.roleFilterSelected];
      this.closeRoleFilterModal();
    },
    selectAllRoles() {
      this.roleFilterSelected = [...this.filteredRoleOptions];
    },
    deselectAllRoles() {
      this.roleFilterSelected = [];
    },
    addRoleFilterClickOutside() {
      this.removeRoleFilterClickOutside();
      setTimeout(() => {
        this.roleFilterClickOutside = (e) => {
          const popover = this.$refs.roleFilterPopover;
          const btn = this.$refs.roleFilterBtn;
          if (popover && popover.contains(e.target)) return;
          if (btn && btn.contains(e.target)) return;
          this.closeRoleFilterModal();
        };
        document.addEventListener("click", this.roleFilterClickOutside);
      }, 0);
    },
    removeRoleFilterClickOutside() {
      if (this.roleFilterClickOutside) {
        document.removeEventListener("click", this.roleFilterClickOutside);
        this.roleFilterClickOutside = null;
      }
    },

    removeEditTransferNumber(index) {
      this.editingClient.transfer_numbers.splice(index, 1)
    },
      async deleteClient(client) {
      // показываем окно подтверждения
      const confirmed = confirm(`Are you sure you want to delete user "${client.user}"?`);
      if (!confirmed) return;

      try {
        const token = localStorage.getItem("token");
        const params = new URLSearchParams({ username: this.username });
        const res = await this.authorizedFetch(`/api/clients/${client.id}?${params.toString()}`, {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!res.ok) {
          alert("Failed to delete customer");
          return;
        }

        // удаляем из локальной таблицы
        this.rows = this.rows.filter(c => c.id !== client.id);
        this.closeEditModal();
        alert(`User "${client.user}" deleted`);
      } catch (err) {
        console.error(err);
        alert("Error deleting customer");
      }
    },
    async fetchClients() {
      const token = localStorage.getItem("token");
      const res = await fetch("/api/clients", {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log(res)
        if (!res.ok) {
        // Токен невалиден или ошибка — очищаем и редиректим
        localStorage.removeItem('token');
        localStorage.removeItem("username");
        window.location.href = '/login';
        return;
      }

      const data = await res.json();
      this.rows = data.items || [];
    },
    async fetchRoles() {
        const token = localStorage.getItem("token");
        try {
            const res = await fetch("/api/roles", {
            headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json();
            this.roleOptions = data.items || [];
            console.log("roleOptions", this.roleOptions);
            console.log("roleOptions")
            console.log(this.roleOptions)
        } catch (e) {
            console.error("Failed to fetch roles:", e);
        }
    },
    async check_role(){
      const token = localStorage.getItem('token');
      const params = new URLSearchParams({ user: this.username });
      const res = await fetch(`/api/role?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      this.roles = data.roles;
      return this.roles
    },
    
    saveChanges() {
        const payload = Array.from(this.editedRows);

        // await fetch('/api/save_clients', { method: 'POST', body: JSON.stringify(payload) })

        this.editedRows.clear();
    },
    


    isEditing(client, field) {
      return (
        this.editingCell &&
        this.editingCell.transfer_number === client.transfer_number &&
        this.editingCell.field === field
      );
    },
    openCreateModal() {
      this.mode = "create"
      this.resetNewClient();
      this.createError = "";
      this.showCreateModal = true;
    },
    addTransferNumber(client = this.newClient) {
      if (!client.transfer_numbers) {
        client.transfer_numbers = [];
      }
      client.transfer_numbers.push("");
    },
    removeTransferNumber(index, client = this.newClient) {
      client.transfer_numbers.splice(index, 1);
    },
    resetNewClient() {
      this.newClient = {
        user: "",
        password: "",
        roles: [],
        transfer_numbers: [],
        company_name: "",
        owner_name: "",
        owner_phone: "",
        contact_name: "",
        contact_phone: "",
        email: "",
        sms_enabled: false,
        price_per_transfer: "",
      };
    },
    closeCreateModal() {
      this.showCreateModal = false;
      this.createError = "";
    },
  toggleActions(id) {
    this.openActionsId = this.openActionsId === id ? null : id
  },
  openEditFromMenu(client) {
    this.openActionsId = null
    this.openEditModal(client)
  },

  async toggleActive(client) {
    try {
      const token = localStorage.getItem("token")

      const res = await this.authorizedFetch(`/api/clients/activate/${client.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          active: !client.active,
          
        }),
      })

      if (!res.ok) {
        alert("Failed to update status")
        return
      }

      client.active = !client.active
      this.openActionsId = null
      await fetch("/api/logs", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + localStorage.getItem("token")
        },
        body: JSON.stringify({
          action_type: `activate user ${client.id}`,
          username: localStorage.getItem("username")
        })
      });
    } catch (e) {
      console.error(e)
      alert("Error updating status")
    }
  },

  handleClickOutsideActions() {
    this.openActionsId = null
  },
  showAddNumberInput() {
    this.addingNumber = true;
    this.newNumber = "";
  },

  confirmAddNumber() {
    const normalized = this.newNumber

    if (!this.isValidUSPhone(normalized)) {
      alert("Phone must be US number: 11 digits starting with 1")
      return
    }

    this.newClient.transfer_numbers.push(normalized)
    this.newNumber = ""
    this.addingNumber = false
  },
  cancelAddNumber() {
    this.newNumber = "";
    this.addingNumber = false;
  },
  removeTransferNumber(index) {
    this.newClient.transfer_numbers.splice(index, 1);
  },
  isValidUSPhone(phone) {
    if (!phone) return false

    return /^\+1\d{10}$/.test(phone)
  },

  stopEdit() {
          this.editingCell = null;
        },
  openEditModal(client) {
    console.log(client)
    this.editingClient = JSON.parse(JSON.stringify(client))
    this.editingClient.password = ""
    if (
      this.editingClient.price_per_transfer === undefined ||
      this.editingClient.price_per_transfer === null
    ) {
      this.editingClient.price_per_transfer =
        this.editingClient.pricePerTransfer ?? ""
    }
    this.showEditModal = true
  },
    closeEditModal() {
      this.showEditModal = false
      this.editingClient = null
    },
    async createClient() {
      if (!this.newClient.transfer_numbers || this.newClient.transfer_numbers.length === 0) {
        alert("Please add at least one transfer number.");
        return;
      }
      if (!this.isPasswordStrong(this.newClient.password)) {
        alert("Password must be at least 8 characters, include at least 1 uppercase letter and 1 special character.");
        return;
      }
      const phoneFields = [
        { field: "owner_phone", label: "Owner phone" },
        { field: "contact_phone", label: "Contact phone" },
      ];

      for (const item of phoneFields) {
        const value = this.newClient[item.field];
        if (value && !this.isValidUSPhone(value)) {
          alert(`${item.label} must be a US number (+1XXXXXXXXXX).`);
          return;
        }
      }
      const token = localStorage.getItem("token");

      const res = await this.authorizedFetch("/api/clients", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(this.newClient)
      });

      if (!res.ok) {
        if (res.status === 409) {
          const errData = await res.json().catch(() => ({}));
          this.createError = errData.error || "User already exists";
        } else {
          this.createError = "Failed to create user. Please try again.";
        }
        return;
      }
      this.createError = "";
      const logPayload = { ...this.newClient };
      delete logPayload.password;
      await fetch("/api/logs", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + localStorage.getItem("token")
        },
        body: JSON.stringify({
          action_type: `create user payload=${JSON.stringify(logPayload)}`,
          username: localStorage.getItem("username")
        })
      });

      const data = await res.json();

      

      alert("Customer created");
      this.fetchClients();
      this.closeCreateModal()
    },
    async authorizedFetch(url, options = {}) {
      let token = localStorage.getItem("token");

      if (!options.headers) options.headers = {};
      options.headers["Authorization"] = `Bearer ${token}`;

      let response = await fetch(url, options);

      // Если токен истёк — пробуем рефреш
      if (response.status === 401) {
        const refresh_token = localStorage.getItem("refresh_token");
        if (!refresh_token) {
          this.logout();
          return;
        }

        // Запрос на рефреш токена
        const refreshRes = await fetch("/api/refresh", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ refresh_token })
        });

        if (!refreshRes.ok) {
          // Если рефреш не прошёл — редирект на логин
          this.logout();
          return;
        }

        const data = await refreshRes.json();
        token = data.token;
        localStorage.setItem("token", token);

        // Повторяем исходный запрос с новым токеном
        options.headers["Authorization"] = `Bearer ${token}`;
        response = await fetch(url, options);
      }

      return response;
    },
    goToHome() {
        if (this.roles.includes('admin')) {
            this.$router.push('/')
          } else if (this.roles.includes('customer')) {
            this.$router.push('/calls')
          } else if (this.roles.includes('cross_sales_configurator')) {
            this.$router.push('/Calls_quota')
          }
    },
    async updateClient(client) {
      const newPassword = (client.password || "").trim();
      if (newPassword && !this.isPasswordStrong(newPassword)) {
        alert("Password must be at least 8 characters, include at least 1 uppercase letter and 1 special character.");
        return;
      }
      const token = localStorage.getItem("token");
      const payload = { ...client };
      if (!newPassword) {
        delete payload.password;
      }
      const res = await this.authorizedFetch(`/api/clients/${client.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });
      if (!res || !res.ok) {
        alert("Failed to update customer");
        return;
      }
      const logPayload = { ...client };
      if (newPassword) {
        logPayload.password = "[redacted]";
      } else {
        delete logPayload.password;
      }
      await fetch("/api/logs", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token")
        },
        body: JSON.stringify({
          action_type: `update user id=${client.id} payload=${JSON.stringify(logPayload)}`,
          username: localStorage.getItem("username")
        })
      });
      this.fetchClients();
      this.closeEditModal();
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.currentPage = 1; // сбрасываем на первую страницу при фильтре
      }
    },
  }
};
</script>

<style scoped>
/* User filter — same style as Ringbacalls */
.campaign-header-cell-inner {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.campaign-header-cell span {
  font-weight: 600;
}
.filter-icon-btn {
  position: relative;
  width: auto;
  height: auto;
  padding: 2px 4px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #6c757d;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}
.filter-icon-btn:hover {
  color: #4e54c8;
}
.filter-icon-btn.active {
  color: #4e54c8;
}
.filter-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  font-size: 9px;
  font-weight: 700;
  color: #fff;
  background: #4e54c8;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.filter-popover {
  position: fixed;
  z-index: 9999;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border: 1px solid #e0e0e0;
  width: 280px;
  max-height: none;
  display: flex;
  flex-direction: column;
}
.filter-popover-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #eee;
}
.filter-popover-title {
  font-size: 13px;
  font-weight: 600;
}
.filter-popover-close {
  background: none;
  border: none;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  color: #999;
  padding: 0 4px;
}
.filter-popover-close:hover {
  color: #333;
}
.filter-popover-body {
  padding: 10px 12px;
}
.filter-popover-search {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  box-sizing: border-box;
}
.filter-popover-footer {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  padding: 10px 12px;
  border-top: 1px solid #eee;
}
.filter-popover-role.filter-popover {
  width: 320px;
  max-height: 400px;
}
.filter-popover-active.filter-popover {
  width: 200px;
}
.filter-popover-active .filter-popover-item {
  padding: 8px 10px;
}
.filter-popover-active input[type="radio"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
  accent-color: #4e54c8;
}
.filter-popover-list {
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 6px;
  margin-top: 8px;
}
.filter-popover-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}
.filter-popover-item:last-child {
  border-bottom: none;
}
.filter-popover-item:hover {
  background: #f8f9ff;
}
.filter-popover-item input[type="checkbox"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
}
.filter-popover-empty {
  padding: 16px;
  text-align: center;
  color: #888;
  font-size: 12px;
}

.logout-modal-overlay {
  position: absolute; 
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  z-index: 10000;
}

.logout-modal-overlay .modal-content {
  position: absolute;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  min-width: 200px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
  animation: scaleIn 0.2s ease;
}

.col-active {
  width: 140px;
  min-width: 140px;
  max-width: 140px;
  text-align: center; /* по центру, как у actions */
}

.actions-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

/* СИНИЕ ТРОЕТОЧИЕ, БЕЗ ВСЕГО */
.dots-btn {
  background: none;
  border: none;
  padding: 4px 6px;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: #4f46e5;
}

.dots-btn:hover {
  color: #4338ca;
}

.actions-popover {
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translate(-8px, -50%);
  background: #ffffff;
  border-radius: 10px;
  padding: 6px;
  min-width: 150px;
  box-shadow:
    0 10px 25px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  z-index: 20;
}

/* КНОПКИ ВНУТРИ */
.popover-btn {
  width: 100%;
  background: none;
  border: none;
  padding: 10px 12px;
  font-size: 14px;
  text-align: left;
  border-radius: 8px;
  cursor: pointer;
  color: #111827;
}

.popover-btn:hover {
  background: #f3f4f6;
}

.popover-btn.secondary {
  color: #dc2626;
}
.confirm-number-btn {
  background: none;
  border: none;
  padding: 4px;
  margin-left: 8px;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  color: #9ca3af; /* серый по умолчанию */
  transition: color 0.15s ease, transform 0.15s ease;
}

.confirm-number-btn:hover {
  color: #16a34a; /* аккуратный зелёный */
  transform: scale(1.1);
}

.confirm-number-btn:active {
  transform: scale(0.95);
}
.popover-btn.secondary:hover {
  background: #fee2e2;
}
.login-title {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: #4e54c8;
}
.toggle-switch {
  position: relative;
  width: 50px;
  height: 26px;
}
.subtitle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.subtitle {
  margin: 0;
}

.add-user-btn {
  margin-top: 4px;
  white-space: nowrap;
}

.toggle-switch input {
  opacity: 0;
  width: 50px;   /* делаем input всё ещё кликабельным */
  height: 26px;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  margin: 0;
}


.toggle-switch .slider {
  position: absolute;
  pointer-events: none; /* чтобы клики проходили к input */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 26px;
  transition: 0.4s;
}
.company-alone {
  grid-column: 1 / -1;   /* занимает всю строку */
}

.company-alone input {
   max-width: calc(50% - 7.5px); 
}
.toggle-switch .slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  border-radius: 50%;
  transition: 0.4s;
}

.toggle-switch input:checked + .slider {
  background-color: #4f46e5; /* синий как кнопка */
}

.toggle-switch input:checked + .slider:before {
  transform: translateX(24px);
  
}
.remove-number-btn {
  background: none;
  border: none;
  padding: 4px;
  margin-left: 8px;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  color: #9ca3af; /* серый */
  transition: color 0.15s ease, transform 0.15s ease;
}

.remove-number-btn:hover {
  color: #dc2626;
  transform: scale(1.1);
}

.remove-number-btn:active {
  transform: scale(0.95);
}

/* Layout */
#reportPage {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px 10px;
  background: linear-gradient(135deg, #1e3c72, #2a5298);
}

.report-card {
  width: 100%;
  max-width: none;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.page-header {
  margin-bottom: 14px;
}
.title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-header h1 {
  margin: 0;
  font-size: 28px;
}

.subtitle {
  margin-top: 4px;
  color: #666;
}

/* Table */
.table-wrapper {
  padding: 0;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size:14px;
}

.table th,
.table td {
  border: 1px solid #e5e7eb; /* светло-серый */
  padding: 10px 12px;
  vertical-align: middle;
}

.table th {
  background: #f9fafb;
  font-weight: 600;
  color: #374151;
  text-align: center;
}
.td-right {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.td-center {
  text-align: center;
}

.table tbody tr:hover {
  background-color: #f9fafb;
}

.empty {
  text-align: center;
  padding: 20px;
  color: #9ca3af;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  max-width: 600px;
  width: 90%;          /* адаптивно */
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  animation: scaleIn 0.2s ease;
}

@keyframes scaleIn {
  from { transform: scale(0.8); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
}

/* Форма внутри модалки */
.modal-form .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 20px;
}
.modal-actions-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


@keyframes scaleIn {
  from { transform: scale(0.8); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
}

.right-actions {
  display: flex;
  gap: 12px;
}


/* Кнопки */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.status-badge .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

/* ACTIVE */
.status-badge.active {
  background: #ecfdf5;
  color: #065f46;
}

.status-badge.active .dot {
  background: #10b981;
}

/* INACTIVE */
.status-badge.inactive {
  background: #fef2f2;
  color: #7f1d1d;
}
.status-badge.inactive .dot {
  background: #ef4444;
}
/* Анимация появления/исчезновения через Vue Transition */
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

.table th {
  background: #f7f8fa;
  font-weight: 600;
  text-align: left;
}

.table thead th {
  text-align: left;
}

.table td.center,
.table th.center {
  text-align: center;
}

.table tr:hover {
  background: #fafafa;
}

/* Inputs */
.table-input {
  width: 100%;
  height: 100%;
  padding: 6px 8px;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 6px;
}

/* Buttons */
.btn {
  padding: 6px 14px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 500;
}

.btn-primary {
  background: #4f46e5;
  color: white;
}

.btn-primary:hover {
  background: #4338ca;
}

.btn-secondary {
  background: #e5e7eb;
  color: #111;
}

.btn-secondary:hover {
  background: #d1d5db;
}
.transfer-numbers-wrapper {
  max-height: 300px; /* высота окна с номерами */
  overflow-y: auto;  /* вертикальный скролл при переполнении */
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px;
  margin-bottom: 8px;
}

transfer-number-row {
  display: flex;
  align-items: center; /* выравнивание по центру по вертикали */
  gap: 8px;            /* расстояние между элементами */
  margin-bottom: 6px;
}

.transfer-number-row input {
  flex: 1;
  width: 150px; 
  padding: 10px 12px;
  font-size: 16px;
  min-height: 40px;
  border-radius: 6px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

.remove-number-btn,
.confirm-number-btn {
  background: none;
  border: none;
  padding: 4px;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  transition: color 0.15s ease, transform 0.15s ease;
}

.remove-number-btn {
  color: #9ca3af;
}

.remove-number-btn:hover {
  color: #dc2626;
  transform: scale(1.1);
}

.remove-number-btn:active {
  transform: scale(0.95);
}

.confirm-number-btn {
  color: #9ca3af;
}

.confirm-number-btn:hover {
  color: #16a34a;
  transform: scale(1.1);
}

.confirm-number-btn:active {
  transform: scale(0.95);
}

/* Footer */
.footer-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end; 
}
.sms-toggle {
  display: inline-block;
  cursor: pointer;
  font-size: 24px; /* размер галочки/крестика */
  text-align: center;
  width: 100%;
  user-select: none; /* чтобы нельзя было выделять символ */
}

.checkbox-wrapper {
  position: relative;
  display: inline-block;
  width: 40px; /* ширина ячейки */
  height: 40px; /* высота ячейки */
  text-align: center;
  cursor: pointer;
}

.checkbox-wrapper input[type="checkbox"] {
  opacity: 0; /* прячем стандартный чекбокс */
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  cursor: pointer;
}

.custom-check {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  width: 40px;    /* ширина клетки */
  height: 40px;   /* высота клетки */
  border: 2px solid #ccc; /* видимая рамка */
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
}
.custom-check:hover {
  background-color: #f0f0f0; /* эффект наведения */
  border-color: #888;
}

.multiselect-sm .vs__dropdown-toggle {
  min-height: 32px;
  font-size: 12px;
}
/* Empty state */
.empty {
  text-align: center;
  padding: 20px;
  color: #888;
  
}
.table-section {
  padding-left: 16px;
  padding-right: 16px;
}
@media (min-width: 1024px) {
  .table-section {
    padding-left: 160px;
    padding-right: 160px;
  }
}

@media (max-width: 768px) {
  .modal-content {
    width: 95%;      
    max-width: 95%; 
    padding: 16px;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .transfer-numbers-wrapper {
    max-height: 200px; /* поменьше высота на мобиле */
  }

  .form-field input,
  .form-field .vs__dropdown-toggle {
    font-size: 14px; /* под мобильный текст */
  }
}

@media (max-width: 768px) {
  .modal-form .form-grid {
    grid-template-columns: 1fr; /* одна колонка на мобильных */
    gap: 12px;
  }

  .modal-content {
    width: 95%;
    max-width: 95%;
    padding: 16px;
  }

  .transfer-numbers-wrapper {
    max-height: 200px;
  }

  .form-field input,
  .form-field .vs__dropdown-toggle {
    font-size: 14px;
  }
}
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    max-width: 95%;
    padding: 16px;
    max-height: 85vh;  /* чуть меньше на телефоне */
  }
}
.modal-content {
  max-height: 90vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* плавный скролл на iOS */
}
.multiselect-table .vs__dropdown-toggle {
  width: 100% !important;
  box-sizing: border-box;
}
.table-wrapper {
  overflow: visible;
}
.table-scroll {
  overflow-x: auto;
}
.table-actions {
  display: flex;
  gap: 6px;          /* расстояние между кнопками */
  justify-content: center;
}

.table-actions .btn {
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 4px;
  min-width: 60px;
  text-align: center;
  border: 1px solid #ccc;
  background: white; 
}

.table-actions .btn-primary {
  background: white;        
  color: #4f46e5;
  border-color: #4f46e5;
  border: 1px solid #4f46e5; 
}
.table-actions .btn-primary:hover {
  background: #4338ca;
}

.table-actions .btn-danger {
    background: white;        
  color: #ef4444;
  border-color: #ef4444;
  border: 1px solid #ef4444;
}
.table-actions .btn-danger:hover {
  background: #fee2e2; 
}
.multiselect-table {
  width: 100% !important;
  min-width: 120px;
  font-size: 14px;
}
.btn-danger {
  background: #ef4444;
  color: white;
}

.btn-danger:hover {
  background: #dc2626;
}

.multiselect-table .vs__dropdown-toggle {
  width: 100% !important;
  box-sizing: border-box;
}
.col-actions {
  width: 140px;
  min-width: 140px;
  max-width: 140px;
}


.login-title .brand {
  color: #4e54c8;
  text-decoration: none;
}
.login-title .brand:hover {
  text-decoration: underline;
}
.modal-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

.modal-section {
  margin-bottom: 25px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #555;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.form-field {
  display: flex;
  flex-direction: column;
}

.form-field label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 6px;
  padding-left: 4px; 
  color: #555;
}

.form-field input {
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
  outline: none;
}

.form-field input:disabled {
  background: #f7f7f7;
  color: #888;
}

.checkbox-field {
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}

.create-error {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding: 10px 14px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  color: #b91c1c;
  font-size: 14px;
  font-weight: 500;
}
.create-error::before {
  content: "⚠";
  font-size: 16px;
  flex-shrink: 0;
}

/* Transition */
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>